import React from 'react';

import './FreightList.css';

import CumulativeTotals from "./CumulativeTotals";
import {
    PublicApiConsignmentFreightResponse,
    PublicApiCumulativeTotalsByProgressResponse,
    PublicApiCumulativeTotalsResponse
} from "../Representation";


interface FreightListProps {
    freight?: PublicApiConsignmentFreightResponse[] | null
    cumulativeTotals: PublicApiCumulativeTotalsResponse[]
    cumulativeTotalsByProgress: PublicApiCumulativeTotalsByProgressResponse
    cumulativeTotalsConsignmentCount: number
}

const FreightList = (
    props: FreightListProps
) => {

    const freight = props.freight || [];

    return (
        <div className="FreightList">
            {freight.length > 0
                ? <h3>Freight</h3>
                : null
            }
            {freight.map((row, index) => {
                const qty = row.netQuantity || row.orderedQuantity;
                return (
                    <div key={"row_" + index}>
                        <p className="title">{row.description}</p>
                        <p className="qty">{qty} <span className="ConsignmentFreight-uom">{ row.unitOfMeasureDescription }</span></p>
                    </div>
                );
            })}

            <CumulativeTotals
                cumulativeTotals={props.cumulativeTotals}
                cumulativeTotalsByProgress={props.cumulativeTotalsByProgress}
                cumulativeTotalsConsignmentCount={props.cumulativeTotalsConsignmentCount}
            />
        </div>
    )

}

export default FreightList;
